function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
/**
 * Vault rental checkout transactions.
 *
 * createCheckOutRentalTransaction — package file_id + reconstructed access script
 * (file_access_script + CHECKPATHHOP hops from tx.msg.data.path) for the Vault server.
 *
 * receiveCheckOutRentalTransaction — instantiate LOAN_SCRIPT from the FIRST
 * hop with value.delegated == 0, hash it, and submit that hash as Archive
 * owner. FILE_SCRIPT remains the access_script Archive evaluates.
 *
 * Mixed onto the Vault module instance (same pattern as Store lib/transactions).
 */

var Transaction = require('../../../../lib/saito/transaction')["default"];
var loan = require('../contracts/loan');

/**
 * Build and sign a Vault checkout transaction for a received rental NFT transfer.
 * Does not mutate the NFT transfer `tx`.
 *
 * @param {object} tx received store-nft-rental Bound transfer (list-asset / fulfillment)
 * @returns {Promise<object|null>} signed checkout transaction, or null
 */
function createCheckOutRentalTransaction(_x) {
  return _createCheckOutRentalTransaction.apply(this, arguments);
}
/**
 * Server-side receive path for peer request "vault checkout rental".
 *
 * Structural checks only (file_id / access_script). Authorization is performed
 * solely inside Archive.updateTransaction, which builds context.db from the
 * actual SET fields and evaluates access_script once with request_tx.
 *
 * @param {object} tx peer-request transaction (data = serialized checkout tx)
 * @param {function} mycallback
 * @returns {Promise<number>} 1 when handled
 */
function _createCheckOutRentalTransaction() {
  _createCheckOutRentalTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(tx) {
    var _source_msg$data, _source_msg$data2, _source_msg$data3;
    var source_msg, file_id, routing_path, file_access_script, locking_script, _attach_path_witness, access_script, newtx, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (tx) {
            _context.n = 1;
            break;
          }
          return _context.a(2, null);
        case 1:
          source_msg = typeof tx.returnMessage === 'function' ? tx.returnMessage() || {} : tx.msg || {};
          file_id = String((source_msg === null || source_msg === void 0 || (_source_msg$data = source_msg.data) === null || _source_msg$data === void 0 ? void 0 : _source_msg$data.file_id) || '').trim();
          routing_path = Array.isArray(source_msg === null || source_msg === void 0 || (_source_msg$data2 = source_msg.data) === null || _source_msg$data2 === void 0 ? void 0 : _source_msg$data2.path) ? source_msg.data.path : [];
          file_access_script = source_msg === null || source_msg === void 0 || (_source_msg$data3 = source_msg.data) === null || _source_msg$data3 === void 0 ? void 0 : _source_msg$data3.file_access_script;
          if (file_id) {
            _context.n = 2;
            break;
          }
          return _context.a(2, null);
        case 2:
          if (file_access_script) {
            _context.n = 3;
            break;
          }
          return _context.a(2, null);
        case 3:
          _context.p = 3;
          locking_script = typeof file_access_script === 'string' ? JSON.parse(file_access_script) : JSON.parse(JSON.stringify(file_access_script));
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          return _context.a(2, null);
        case 5:
          //
          // Attach NFT transfer path as CHECKPATHHOP.witness.hops (same hop objects
          // written by Store saito-nft-transfer). Walk OR/AND so the nested rental
          // CHECKPATHHOP receives the witness; do not invent a new hop format.
          //
          _attach_path_witness = function attach_path_witness(node) {
            if (!node || _typeof(node) !== 'object') {
              return;
            }
            var op = String(node.op || '').toUpperCase();
            if ((op === 'AND' || op === 'OR' || op === 'NOT') && Array.isArray(node.args)) {
              for (var i = 0; i < node.args.length; i++) {
                _attach_path_witness(node.args[i]);
              }
              return;
            }
            if (op === 'CHECKPATHHOP') {
              node.witness = {
                hops: routing_path
              };
            }
          };
          _attach_path_witness(locking_script);
          access_script = JSON.stringify(locking_script);
          _context.n = 6;
          return this.app.wallet.createUnsignedTransaction();
        case 6:
          newtx = _context.v;
          newtx.msg = {
            module: 'Vault',
            request: 'vault checkout rental',
            access_script: access_script,
            data: {
              file_id: file_id,
              path: routing_path
            }
          };
          _context.n = 7;
          return newtx.sign();
        case 7:
          return _context.a(2, newtx);
      }
    }, _callee, this, [[3, 4]]);
  }));
  return _createCheckOutRentalTransaction.apply(this, arguments);
}
function receiveCheckOutRentalTransaction(_x2, _x3) {
  return _receiveCheckOutRentalTransaction.apply(this, arguments);
}
function _receiveCheckOutRentalTransaction() {
  _receiveCheckOutRentalTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(tx, mycallback) {
    var _peer_txmsg$data, _peer_txmsg$data2, _selected_hop_value, _this$app$core, peer_tx, peer_txmsg, file_id, access_script, path, selected_hop_to, selected_hop_value, decoded_hops, creator_pk, _cph$witness, script_obj, _find_checkpathhop, cph, hops, expected_from, i, _value_obj$timestamp, _value_obj, _value_obj$expires_at, _value_obj2, _value_obj$delegated, _value_obj3, hop, value_obj, selected, expires_at, loan_script, loan_script_json, loan_access_hash, result, _t2, _t3;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          peer_tx = new Transaction();
          peer_tx.deserialize_from_web(this.app, tx.returnMessage().data);
          peer_txmsg = peer_tx.returnMessage() || {};
          file_id = String((peer_txmsg === null || peer_txmsg === void 0 || (_peer_txmsg$data = peer_txmsg.data) === null || _peer_txmsg$data === void 0 ? void 0 : _peer_txmsg$data.file_id) || '').trim();
          access_script = peer_txmsg.access_script != null ? typeof peer_txmsg.access_script === 'string' ? peer_txmsg.access_script : JSON.stringify(peer_txmsg.access_script) : '';
          path = Array.isArray(peer_txmsg === null || peer_txmsg === void 0 || (_peer_txmsg$data2 = peer_txmsg.data) === null || _peer_txmsg$data2 === void 0 ? void 0 : _peer_txmsg$data2.path) ? peer_txmsg.data.path : [];
          selected_hop_to = null;
          selected_hop_value = null;
          decoded_hops = [];
          creator_pk = null;
          try {
            script_obj = JSON.parse(access_script);
            _find_checkpathhop = function find_checkpathhop(node) {
              if (!node || _typeof(node) !== 'object') {
                return null;
              }
              if (String(node.op || '').toUpperCase() === 'CHECKPATHHOP') {
                return node;
              }
              if (Array.isArray(node.args)) {
                for (var i = 0; i < node.args.length; i++) {
                  var found = _find_checkpathhop(node.args[i]);
                  if (found) {
                    return found;
                  }
                }
              }
              return null;
            };
            cph = _find_checkpathhop(script_obj);
            creator_pk = (cph === null || cph === void 0 ? void 0 : cph.publickey) || null;
            hops = Array.isArray(cph === null || cph === void 0 || (_cph$witness = cph.witness) === null || _cph$witness === void 0 ? void 0 : _cph$witness.hops) ? cph.witness.hops : path;
            expected_from = creator_pk;
            for (i = 0; i < hops.length; i++) {
              hop = hops[i] || {};
              value_obj = null;
              try {
                value_obj = JSON.parse(Buffer.from(String(hop.value || ''), 'base64').toString('utf8'));
              } catch (err) {
                value_obj = null;
              }
              decoded_hops.push({
                i: i,
                from: expected_from,
                to: hop.to || null,
                timestamp: (_value_obj$timestamp = (_value_obj = value_obj) === null || _value_obj === void 0 ? void 0 : _value_obj.timestamp) !== null && _value_obj$timestamp !== void 0 ? _value_obj$timestamp : null,
                expires_at: (_value_obj$expires_at = (_value_obj2 = value_obj) === null || _value_obj2 === void 0 ? void 0 : _value_obj2.expires_at) !== null && _value_obj$expires_at !== void 0 ? _value_obj$expires_at : null,
                delegated: (_value_obj$delegated = (_value_obj3 = value_obj) === null || _value_obj3 === void 0 ? void 0 : _value_obj3.delegated) !== null && _value_obj$delegated !== void 0 ? _value_obj$delegated : null
              });
              expected_from = hop.to || expected_from;
            }
            // Same selector as FILE_SCRIPT CHECKPATHHOP: FIRST where value.delegated == 0
            selected = decoded_hops.find(function (h) {
              return h.delegated === 0;
            }) || null;
            selected_hop_to = (selected === null || selected === void 0 ? void 0 : selected.to) || null;
            selected_hop_value = selected || null;
          } catch (err) {}
          if (file_id) {
            _context2.n = 1;
            break;
          }
          if (mycallback) {
            mycallback({
              status: 'err',
              err: 'missing_file_id'
            });
          }
          return _context2.a(2, 1);
        case 1:
          if (access_script) {
            _context2.n = 2;
            break;
          }
          if (mycallback) {
            mycallback({
              status: 'err',
              err: 'missing_access_script'
            });
          }
          return _context2.a(2, 1);
        case 2:
          expires_at = (_selected_hop_value = selected_hop_value) === null || _selected_hop_value === void 0 ? void 0 : _selected_hop_value.expires_at;
          if (!(!creator_pk || !selected_hop_to || expires_at == null)) {
            _context2.n = 3;
            break;
          }
          if (mycallback) {
            mycallback({
              status: 'err',
              err: 'loan_script_instantiation_failed',
              file_id: file_id
            });
          }
          return _context2.a(2, 1);
        case 3:
          if ((_this$app$core = this.app.core) !== null && _this$app$core !== void 0 && (_this$app$core = _this$app$core.scripting) !== null && _this$app$core !== void 0 && _this$app$core.hash) {
            _context2.n = 4;
            break;
          }
          if (mycallback) {
            mycallback({
              status: 'err',
              err: 'scripting_unavailable',
              file_id: file_id
            });
          }
          return _context2.a(2, 1);
        case 4:
          loan_script = loan.instantiate({
            creator_publickey: creator_pk,
            renter_publickey: selected_hop_to,
            expires_at: expires_at
          });
          loan_script_json = JSON.stringify(loan_script);
          loan_access_hash = this.app.core.scripting.hash(loan_script_json);
          console.log('[VAULT LOAN SCRIPT]\n' + JSON.stringify(loan_script, null, 2));
          console.log('[VAULT LOAN SCRIPT HASH]\n' + loan_access_hash);

          //
          // Metadata-only update: tx === null so archives.tx is not rewritten.
          // obj.sig is the WHERE lookup key only (Archive excludes it from SET).
          // request_tx = peer request for Archive script evaluation (REQUESTER).
          // Do NOT evaluate access_script here — Archive builds context.db from the
          // actual SET fields and evaluates once inside updateTransaction().
          //
          _context2.p = 5;
          _context2.n = 6;
          return this.app.storage.updateTransaction(null, {
            sig: file_id,
            owner: loan_access_hash,
            access_script: access_script,
            request_tx: tx
          }, 'localhost');
        case 6:
          result = _context2.v;
          _context2.n = 8;
          break;
        case 7:
          _context2.p = 7;
          _t2 = _context2.v;
          if (mycallback) {
            mycallback({
              status: 'err',
              err: String((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || _t2),
              file_id: file_id,
              result: 0
            });
          }
          return _context2.a(2, 1);
        case 8:
          if (result) {
            _context2.n = 9;
            break;
          }
          if (mycallback) {
            mycallback({
              status: 'err',
              err: 'archive_update_denied',
              file_id: file_id,
              result: 0
            });
          }
          return _context2.a(2, 1);
        case 9:
          if (mycallback) {
            mycallback({
              status: 'ok',
              file_id: file_id,
              result: result
            });
          }
          _context2.n = 11;
          break;
        case 10:
          _context2.p = 10;
          _t3 = _context2.v;
          if (mycallback) {
            mycallback({
              status: 'err',
              err: String((_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || _t3)
            });
          }
        case 11:
          return _context2.a(2, 1);
      }
    }, _callee2, this, [[5, 7], [0, 10]]);
  }));
  return _receiveCheckOutRentalTransaction.apply(this, arguments);
}
module.exports = {
  createCheckOutRentalTransaction: createCheckOutRentalTransaction,
  receiveCheckOutRentalTransaction: receiveCheckOutRentalTransaction
};